import { type FC } from 'react'

import { ProductPageOdsDialogMainInfoSection } from './ProductPageOdsDialogMainInfoSection'
import { ProductPageOdsDialogVideoConsultationStepsSection } from './ProductPageOdsDialogVideoConsultationStepsSection'

export const ProductPageOdsDialogFeatureDescription: FC<{
  isVideoConsultationAndExperimentOdsV1Enabled: boolean
}> = ({ isVideoConsultationAndExperimentOdsV1Enabled }) =>
  isVideoConsultationAndExperimentOdsV1Enabled ? (
    <ProductPageOdsDialogVideoConsultationStepsSection />
  ) : (
    <ProductPageOdsDialogMainInfoSection />
  )
